import { useMutation } from "@tanstack/react-query";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useCancelService = () =>
  useMutation({
    mutationFn: async (serviceId: string) => {
      const res = await apiClient.patch(ENDPOINTS.SERVICES.CANCEL_SERVICE(serviceId));
      return res.data;
    },
  });